import { Link } from "react-router-dom";
import Logo from "./Logo";
import { CONTACT, whatsappLink } from "../data/content";

const NAV = [
  { to: "/services", label: "Services" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/process", label: "Process" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

const SOCIALS = [
  { label: "Instagram", href: CONTACT.instagram },
];

export default function Footer() {
  return (
    <footer className="bg-espresso text-ivory" data-testid="site-footer">
      <div className="container-lux pt-20 pb-10">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Logo tone="light" />
            <p className="mt-6 max-w-sm text-[15px] font-light leading-relaxed text-ivory/60">
              A premium interior design studio in Hyderabad — crafting warm,
              editorial homes and workspaces from first sketch to final styling.
            </p>
            <a
              href={whatsappLink()}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-whatsapp-link"
              className="link-line inline-block mt-6 text-[13px] tracking-[0.14em] uppercase text-gold"
            >
              Chat on WhatsApp
            </a>
          </div>

          <div className="lg:col-span-2">
            <p className="overline-label !text-gold">Studio</p>
            <ul className="mt-5 space-y-3">
              {NAV.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase()}`}
                    className="link-line text-[15px] font-light text-ivory/70 hover:text-ivory"
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-2">
            <p className="overline-label !text-gold">Follow</p>
            <ul className="mt-5 space-y-3">
              {SOCIALS.map((s) => (
                <li key={s.label}>
                  <a
                    href={s.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    data-testid={`footer-social-${s.label.toLowerCase()}`}
                    className="link-line text-[15px] font-light text-ivory/70 hover:text-ivory"
                  >
                    {s.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-3">
            <p className="overline-label !text-gold">Visit</p>
            <address className="mt-5 space-y-3 text-[15px] font-light not-italic text-ivory/70">
              <p data-testid="footer-address">{CONTACT.address}</p>
              <p>
                <a
                  href={`tel:+${CONTACT.whatsapp}`}
                  data-testid="footer-phone-link"
                  className="link-line hover:text-ivory"
                >
                  {CONTACT.phoneDisplay}
                </a>
              </p>
              <p>
                <a
                  href={`mailto:${CONTACT.email}`}
                  data-testid="footer-email-link"
                  className="link-line hover:text-ivory"
                >
                  {CONTACT.email}
                </a>
              </p>
              <p className="text-ivory/40 text-sm">{CONTACT.hours}</p>
            </address>
          </div>
        </div>

        <div className="mt-20 overflow-hidden select-none" aria-hidden="true">
          <p className="font-serif leading-[0.85] text-center text-[17.5vw] tracking-[0.06em] text-ivory/[0.07] whitespace-nowrap">
            AUREA LIVING
          </p>
        </div>

        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-ivory/10 pt-6">
          <p className="text-[12px] text-ivory/40">
            © {new Date().getFullYear()} Aurea Living. Crafted in Hyderabad.
          </p>
          <p className="text-[12px] text-ivory/40">
            Interiors composed in light &amp; gold
          </p>
        </div>
      </div>
    </footer>
  );
}
